"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.isFullDateStrInPast = exports.excelDateToFullDateStr = exports.fullDateStrToWeekNumber = exports.fullDateStrToQuarter = exports.extractDateAttributesFromFullDateStr = exports.fullDateStrToDate = exports.optionalOffsetFromFullDateStr = exports.offsetFromFullDateStr = exports.fullDateStrToDateTime = exports.fullDateStrToStrOptional = exports.fullDateStrToSlashedDateStr = exports.fullDateStrToEpoch = exports.epochToFullDateStr = exports.epochToSlashedDateStrWithTime = exports.epochToSlashedDateStr = exports.epochToLocaleDateString = exports.optionalFullDateStrToIso = exports.fullDateStrToIso = exports.fullDateStrToShortMonthDayYearString = exports.fullDateStrToShortMonthDayString = exports.fullDateStrToHumanDateString = exports.dateToHumanDateString = exports.optionalDateToFullDateStr = exports.dateToUTCFullDateString = exports.dateToLocalFullDateStringSystemOnly = exports.dateToLocalFullDateString = exports.dateToFullDateString = exports.dateToIsoString = exports.fullDateStrToStr = exports.validateFullDateTimeStr = exports.validateFullDateStr = exports.dateTimetoFullDateTimeStr = exports.strToDateTime = exports.strToFullDateStr = exports.optionalJSDateToUtcString = exports.datetimeToFullDateStr = void 0;
const _ = __importStar(require("lodash"));
const luxon_1 = require("luxon");
const commonConsts = __importStar(require("../consts"));
const error_1 = require("../error");
const commonTypeguards = __importStar(require("../typeguards"));
const consts_1 = require("./consts");
const datetime_1 = require("./datetime");
/**
 * This file should contain all utilities related to date string manipulation
 * NOTE:
 * There are some functions suck as `*ToFullDateStr`, which may benefit from using function overloading.
 * I'm currently not overloading function for a few reasons:
 *  1. I don't know how to do this cleanly via arrow function in Typescript
 *  2. overloading can be confusing, if not used properly
 */
/**
 * converts Luxon DateTime object to finley standard Util.FullDateStr string format
 * @param val: input DateTime luxon object
 * @returns Util.FullDateStr
 */
const datetimeToFullDateStr = (val) => val.toFormat(consts_1.formatFullDateStr);
exports.datetimeToFullDateStr = datetimeToFullDateStr;
/**
 * converts Luxon DateTime object to datetime string
 * @param val: input DateTime luxon object
 * @returns string
 */
const optionalJSDateToUtcString = (val, fmt) => {
    if (_.isNil(val) || !(val instanceof Date)) {
        return '';
    }
    const dateTimeUtc = luxon_1.DateTime.fromJSDate(val).toUTC();
    if (!fmt) {
        // should be e.g. 2021-08-02T16:34:10.801Z
        return dateTimeUtc.toISO();
    }
    return dateTimeUtc.toFormat(fmt);
};
exports.optionalJSDateToUtcString = optionalJSDateToUtcString;
/**
 * converts date string in specified date string format to Util.FullDateStr
 * formats here: https://github.com/moment/luxon/blob/master/docs/formatting.md
 * @param val: input in String
 * @param fmt: dateformat in String
 * @returns Util.FullDateStr
 */
const strToFullDateStr = (val, fmt) => {
    const parsedDatetime = luxon_1.DateTime.fromFormat(val, fmt);
    if (!parsedDatetime.isValid) {
        throw new Error(`${parsedDatetime.invalidReason}: ${parsedDatetime.invalidExplanation}`);
    }
    return (0, exports.datetimeToFullDateStr)(parsedDatetime);
};
exports.strToFullDateStr = strToFullDateStr;
/**
 * converts date string in specified date string format to Util.FullDateStr
 * formats here: https://github.com/moment/luxon/blob/master/docs/formatting.md
 * @param val: input in String
 * @param fmt: dateformat in String
 * @returns DateTime
 */
const strToDateTime = (val, fmt, defaultTz) => {
    // https://moment.github.io/luxon/api-docs/index.html#datetimefromformat
    const options = {};
    if (defaultTz) {
        options.zone = defaultTz;
    }
    const parsedDatetime = luxon_1.DateTime.fromFormat(val, fmt, options);
    if (!parsedDatetime.isValid) {
        throw new Error(`${parsedDatetime.invalidReason}: ${parsedDatetime.invalidExplanation}`);
    }
    return parsedDatetime;
};
exports.strToDateTime = strToDateTime;
// convert to UTC ISO8601
const dateTimetoFullDateTimeStr = (val) => {
    // formats to ISO8601, e.g. '2017-04-20T11:32:00.000Z'
    const dateTimeStr = val.toUTC().toISO();
    (0, error_1.finleyAssert)(commonTypeguards.isFullDateTimeStr(dateTimeStr), new error_1.FinleyError(`Invalid DateTime ISO string`));
    return dateTimeStr;
};
exports.dateTimetoFullDateTimeStr = dateTimetoFullDateTimeStr;
// TODO: IMO, this method probably can be improve in a few ways:
//  - Input `value` type to be string
//  - Use luxon datetime.isValid()
//  - It would also help to be more generic function like `isValidFullDateStr`
//  - all conversion function can convert and check for validity before returning
/**
 * validate that the GQL value is a valid date in YYYY-MM-DD format. if so, return that date string
 * inspired from https://github.com/Urigo/graphql-scalars
 */
const validateFullDateStr = (value) => {
    if (typeof value !== 'string') {
        throw new TypeError(`Value is not string: ${value}`);
    }
    // validate it's in the `YYYY-MM-DD` format
    const isValidFormat = commonConsts.regExpFullDateStr.test(value);
    if (!isValidFormat) {
        throw new TypeError(`Value is not a valid Util.FullDateStr: ${value}`);
    }
    // validate that it is a valid date, e.g., not something like `2020-13-46`
    const valueAsDate = new Date(value);
    if (!_.isNumber(valueAsDate.getTime())) {
        throw new TypeError(`Value is not a valid Util.FullDateStr: ${value}`);
    }
    // some additional logic to catch invalid dates like `2020-02-30`
    // that we catch by serializing the Date object into an ISO string and checking that our serialized date matches
    // the original value
    const isCalendarDate = valueAsDate.toISOString() === `${value}T00:00:00.000Z`;
    if (!isCalendarDate) {
        throw new TypeError(`Value is not a valid Util.FullDateStr: ${value}`);
    }
    return value;
};
exports.validateFullDateStr = validateFullDateStr;
const validateFullDateTimeStr = (value) => {
    const isValidFullDateTimeStr = commonTypeguards.isFullDateTimeStr(value);
    if (!isValidFullDateTimeStr) {
        throw new TypeError(`Value is not a valid Util.FullDateTimeStr: ${value}`);
    }
    return value;
};
exports.validateFullDateTimeStr = validateFullDateTimeStr;
/**
 * Convert from YYYY-MM-DD to other date string format (such as MM/dd/YYYY)
 */
const fullDateStrToStr = (val, toFmt) => {
    const parsedDatetime = luxon_1.DateTime.fromFormat(val, consts_1.formatFullDateStr);
    if (!parsedDatetime.isValid) {
        throw new Error(`${parsedDatetime.invalidReason}: ${parsedDatetime.invalidExplanation}`);
    }
    return parsedDatetime.toFormat(toFmt);
};
exports.fullDateStrToStr = fullDateStrToStr;
/**
 * converts date to ISO string, defaults zone to America/New_York
 */
const dateToIsoString = (date, zone = 'America/New_York') => {
    return luxon_1.DateTime.fromJSDate(date).setZone(zone).toISO();
};
exports.dateToIsoString = dateToIsoString;
/**
 * Converts JS Date to FullDateStr
 * @param date Date
 * @param zone <Optional> Defaults to `America/New_York`
 * @returns `FullDateStr`
 */
const dateToFullDateString = (date, zone = 'America/New_York') => {
    return luxon_1.DateTime.fromJSDate(date)
        .setZone(zone)
        .toFormat(consts_1.formatFullDateStr);
};
exports.dateToFullDateString = dateToFullDateString;
// common-backend sets the default timezone to 'America/New_York' for luxon
// but not for the system Date object.
// this can lead to unexpected results when using mix of luxon and system date objects.
// making this function dangerous when using from BE code.
const dateToLocalFullDateString = (date) => {
    return luxon_1.DateTime.fromJSDate(date).toFormat(consts_1.formatFullDateStr);
};
exports.dateToLocalFullDateString = dateToLocalFullDateString;
/**
 * Converts JS Date to FullDateStr using only system Date object (no Luxon)
 * Uses the local timezone of the system where the code is running
 * @param date Date object to convert
 * @returns FullDateStr in YYYY-MM-DD format
 */
const dateToLocalFullDateStringSystemOnly = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // getMonth() returns 0-11
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
};
exports.dateToLocalFullDateStringSystemOnly = dateToLocalFullDateStringSystemOnly;
/**
 *
 * converts date to FullDateStr in UTC timezone
 */
const dateToUTCFullDateString = (date) => {
    return luxon_1.DateTime.fromJSDate(date, { zone: 'utc' }).toFormat(consts_1.formatFullDateStr);
};
exports.dateToUTCFullDateString = dateToUTCFullDateString;
/**
 * If date exists, return FullDateStr
 * otherwise return undefined
 */
const optionalDateToFullDateStr = (date, zone) => {
    return date ? (0, exports.dateToFullDateString)(date, zone) : undefined;
};
exports.optionalDateToFullDateStr = optionalDateToFullDateStr;
/**
 * convert Date object to human friendly format. Date() -> `January 5, 2022`
 */
const dateToHumanDateString = (dateVal, locale = 'en-us', zone, hour, minute, second) => {
    return dateVal.toLocaleString(locale, {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        timeZone: zone,
        hour,
        minute,
        second,
    });
};
exports.dateToHumanDateString = dateToHumanDateString;
/**
 * convert Util.FullDateStr to human friendly format. 2022-01-05 -> `January 5, 2022`
 */
const fullDateStrToHumanDateString = (input, locale = 'en-us') => {
    const dt = luxon_1.DateTime.fromFormat(input, 'yyyy-MM-dd');
    return (0, exports.dateToHumanDateString)(dt.toJSDate(), locale, locale === 'en-us' ? 'America/New_York' : undefined);
};
exports.fullDateStrToHumanDateString = fullDateStrToHumanDateString;
/**
 * convert Util.FullDateStr to human friendly format. 2022-01-05 -> `Jan 5`
 */
const fullDateStrToShortMonthDayString = (input, locale = 'en-us') => {
    const dt = luxon_1.DateTime.fromFormat(input, 'yyyy-MM-dd');
    return dt.toJSDate().toLocaleString(locale, {
        month: 'short',
        day: 'numeric',
    });
};
exports.fullDateStrToShortMonthDayString = fullDateStrToShortMonthDayString;
const fullDateStrToShortMonthDayYearString = (input, locale = 'en-us') => {
    const dt = luxon_1.DateTime.fromFormat(input, 'yyyy-MM-dd');
    return dt.toJSDate().toLocaleString(locale, {
        month: 'short',
        day: 'numeric',
        year: 'numeric',
    });
};
exports.fullDateStrToShortMonthDayYearString = fullDateStrToShortMonthDayYearString;
/**
 * Converts FullDateStr to ISO 8601 formatted timestamp
 *
 * Example
 * '1982-05-25' => '1982-05-25T00:00:00.000Z'
 */
const fullDateStrToIso = (date, zone = 'America/New_York') => {
    return luxon_1.DateTime.fromISO(date).setZone(zone).toISO();
};
exports.fullDateStrToIso = fullDateStrToIso;
const optionalFullDateStrToIso = (date, zone) => {
    return date ? (0, exports.fullDateStrToIso)(date, zone) : undefined;
};
exports.optionalFullDateStrToIso = optionalFullDateStrToIso;
/**
 * Converts a date in millis to the local time zone specified. Defaults to EST.
 * @param dateInMillis the date in milliseconds
 * @param tz the Luxon timezone code
 * @returns local timezone date string
 */
const epochToLocaleDateString = (dateInMillis, tz = 'America/New_York', format = luxon_1.DateTime.DATETIME_FULL) => {
    return luxon_1.DateTime.fromMillis(dateInMillis).setZone(tz).toLocaleString(format);
};
exports.epochToLocaleDateString = epochToLocaleDateString;
/**
 * Converts a date in millis to SlashedDateStr format.
 * @param dateInMillis the date in milliseconds
 * @param tz the Luxon timezone code
 * @returns SlashedDateStr
 */
const epochToSlashedDateStr = (dateInMillis, tz = 'America/New_York') => {
    return luxon_1.DateTime.fromMillis(dateInMillis)
        .setZone(tz)
        .toFormat(consts_1.formatSlashedDateStr);
};
exports.epochToSlashedDateStr = epochToSlashedDateStr;
/**
 * Converts a date in millis to SlashedDateStr format.
 * @param dateInMillis the date in milliseconds
 * @param tz the Luxon timezone code
 * @returns SlashedDateStr
 */
const epochToSlashedDateStrWithTime = (dateInMillis, tz = 'America/New_York') => {
    return luxon_1.DateTime.fromMillis(dateInMillis)
        .setZone(tz)
        .toFormat('M/d/yy hh:mm a');
};
exports.epochToSlashedDateStrWithTime = epochToSlashedDateStrWithTime;
const epochToFullDateStr = (dateInMillis, tz = 'America/New_York') => {
    return (0, exports.datetimeToFullDateStr)(luxon_1.DateTime.fromMillis(dateInMillis).setZone(tz));
};
exports.epochToFullDateStr = epochToFullDateStr;
/**
 * converts fullDateStr to epoch, defaults timezone to EST
 */
const fullDateStrToEpoch = (fullDateStr, tz = 'America/New_York') => {
    return luxon_1.DateTime.fromISO(fullDateStr).setZone(tz).toMillis();
};
exports.fullDateStrToEpoch = fullDateStrToEpoch;
/**
 * Given a string representing a full date str in the format "YYYY-MM-DD"
 * return a string representing slashed date str specific type "M/d"
 * @param {FullDateStr} fullDateStr - Util.FullDateStr
 * @returns A string of the form "M/D/yy"
 */
const fullDateStrToSlashedDateStr = (fullDateStr, slashedDateFormat) => {
    return (0, exports.fullDateStrToStr)(fullDateStr, slashedDateFormat);
};
exports.fullDateStrToSlashedDateStr = fullDateStrToSlashedDateStr;
/**
 * converts from YYYY-MM-DD to other date string format (such as MM/dd/YYYY)
 * but input value can be null (optional)
 */
const fullDateStrToStrOptional = (val, toFmt) => {
    if (_.isNil(val)) {
        return null;
    }
    return (0, exports.fullDateStrToStr)(val, toFmt);
};
exports.fullDateStrToStrOptional = fullDateStrToStrOptional;
/**
 * Convert a fullDateStr to luxon DateTime object
 * @param fullDateStr date string in YYYY-MM-DD
 * @returns luxon DateTime object
 */
const fullDateStrToDateTime = (fullDateStr) => {
    (0, exports.validateFullDateStr)(fullDateStr);
    return luxon_1.DateTime.fromFormat(fullDateStr, consts_1.formatFullDateStr);
};
exports.fullDateStrToDateTime = fullDateStrToDateTime;
/**
 * Adds x amount of units from input FullDateString and returns new FullDateStr
 */
const offsetFromFullDateStr = (date, options) => {
    return luxon_1.DateTime.fromISO(date)
        .plus(options)
        .toFormat(consts_1.formatFullDateStr);
};
exports.offsetFromFullDateStr = offsetFromFullDateStr;
const optionalOffsetFromFullDateStr = (date, options) => {
    return date ? (0, exports.offsetFromFullDateStr)(date, options) : undefined;
};
exports.optionalOffsetFromFullDateStr = optionalOffsetFromFullDateStr;
/**
 * Converts FullDateStr to Date
 * Use case: primarily in browser when accessing date picker initialized with FullDateStr
 * Warning: defaults zone to client/system timezone, be careful with timezones!
 */
const fullDateStrToDate = (date) => {
    const [year, month, day] = date.split('-');
    return new Date(parseInt(year, 10), parseInt(month, 10) - 1, parseInt(day, 10));
};
exports.fullDateStrToDate = fullDateStrToDate;
/**
 * Returns { year, month, dayOfMonth } from FullDateStr
 */
const extractDateAttributesFromFullDateStr = (dateStr) => {
    const [year, month, dayOfMonth] = dateStr.split('-');
    return {
        year: parseInt(year, 10),
        month: parseInt(month, 10),
        dayOfMonth: parseInt(dayOfMonth, 10),
    };
};
exports.extractDateAttributesFromFullDateStr = extractDateAttributesFromFullDateStr;
/**
 * Gets the calendar quarter that a FullDateStr is in
 */
const fullDateStrToQuarter = (date) => {
    const jsDate = (0, exports.fullDateStrToDate)(date);
    const quarter = Math.floor((jsDate.getMonth() + 3) / 3);
    return quarter;
};
exports.fullDateStrToQuarter = fullDateStrToQuarter;
/**
 * Gets the calendar week of year that a FullDateStr is in
 */
const fullDateStrToWeekNumber = (date) => {
    const jsDate = (0, exports.fullDateStrToDate)(date);
    return luxon_1.DateTime.fromJSDate(jsDate).weekNumber;
};
exports.fullDateStrToWeekNumber = fullDateStrToWeekNumber;
/** * Converts excel "number of days past 1900-01-1" dates to `FullDateStr`. */
const excelDateToFullDateStr = (excelDate) => {
    // Excel counts dates starting form 1900-01-01.
    const excelStartDate = new Date(1900, 0, 1);
    // 1900-01-01 corresponds to excelDate = 1.
    // Subtract 1 so that excelStartDate + daysPastStart = the right day.
    const stupidExcelDaysPastStart = excelDate - 1;
    // Excel incorrectly treats 1900 as a leap year.
    // 1900-02-28 is excel date 59.
    // 1900-03-01 is excel date 61.
    const daysPastStart = excelDate >= 60 ? stupidExcelDaysPastStart - 1 : stupidExcelDaysPastStart;
    const convertedDate = new Date(excelStartDate);
    convertedDate.setDate(convertedDate.getDate() + daysPastStart);
    // All of these dates were created in our local time zone, so treat them as local time.
    return (0, exports.dateToLocalFullDateString)(convertedDate);
};
exports.excelDateToFullDateStr = excelDateToFullDateStr;
/**
 * Checks if a full date string is in the past or today after business hours (5pm ET)
 */
const isFullDateStrInPast = (date) => {
    const today = (0, datetime_1.currentDateStr)();
    const isPastDate = date < today;
    const currentHour = (0, datetime_1.currentDateTime)().hour; // ET
    const isTodayPostBusinessHours = date === today && currentHour >= 17; // Past 5pm ET
    return isPastDate || isTodayPostBusinessHours;
};
exports.isFullDateStrInPast = isFullDateStrInPast;
// All functions are exported above as individual named exports for ESM compatibility
//# sourceMappingURL=datestr.js.map